<template>
  <div>
    <img class="full_width" src="/images/front_banner.webp">
  </div>
  <div class="row pt-5 pb-5 m-0">
    <div class="col-md-2">
      <ul class="list-group">
        <li v-for="post in posts" :key="post.id">
          <router-link :to="'/post/' + post.id" class="list-group-item m-3 mt-0 mb-1">{{ post.title }}</router-link>
        </li>
      </ul>
    </div>
    <div class="col-md-8">
      <div class="text-center">
        <h4>Main Text Area Here</h4>
        <p>The post text written articles, which will change on monthly basis based.</p>
      </div>
    </div>
    <div class="col-md-2">
      <ul class="list-group">
        <li><a class="list-group-item m-3 mt-0 mb-1" href="#">Link 1</a></li>
        <li><a class="list-group-item m-3 mt-0 mb-1" href="#">Link 2</a></li>
        <li><a class="list-group-item m-3 mt-0 mb-1" href="#">Link 3</a></li>
        <li><a class="list-group-item m-3 mt-0 mb-1" href="#">Link 4</a></li>
        <li><a class="list-group-item m-3 mt-0 mb-1" href="#">Link 5</a></li>
      </ul>
    </div>
  </div>
  <FooterSection />
</template>

<script>
import FooterSection from "../components/FooterSection.vue";
import axios from "axios";

export default {
  components: {
    FooterSection,
  },
  data() {
    return {
      posts: [],
    };
  },
  mounted() {
    axios.get("https://6footspeakeasy.com/api/data.php").then((response) => {
      this.posts = response.data;
    }).catch((error) => {
      console.error("Error fetching posts:", error);
    });
  },
};
</script>

<style>
/* Add styles if needed */

.full_width {
  width: 100%;
}
.list-group {
  list-style: none;
  line-height: 30px;
}
.list-group a {
  background: none !important;
  color: #c4b5a7;
  border: 1px solid #c4b5a7;
}
</style>